
import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Telefono } from '../../../models/telefono.model';
import { TelefonoService } from '../../../services/telefono.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-modal-eliminar-telefono',
  imports: [ToastComponent],
  templateUrl: './modal-eliminar-telefono.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './modal-eliminar-telefono.component.css',
})
export class ModalEliminarTelefonoComponent {
  private readonly telefonoService = inject(TelefonoService);
  private readonly toastService = inject(ToastService);

  cerrar = output<void>();
  telefono = input.required<Telefono>();
  sucursalId = input.required<number>();
  telefonoEliminado = output<number>();

  confirmarEliminar(): void {
    const telefono = this.telefono();

    this.telefonoService.eliminar(this.sucursalId(), telefono.id).subscribe({
      next: () => {
        this.telefonoEliminado.emit(telefono.id);
        this.toastService.show({
          text: 'Teléfono eliminado exitosamente',
          classname: 'bg-green-500 text-white',
          delay: 3000,
        });
        this.cerrar.emit();
      },
      error: (err) => {
        console.error('Error al eliminar el teléfono:', err);
        this.toastService.show({
          text: err.message || 'Error al eliminar el teléfono',
          classname: 'bg-red-500 text-white',
          delay: 5000,
        });
      },
    });
  }

  cerrarModal(): void {
    this.cerrar.emit();
  }
}
